import {Component, Injector, OnInit} from '@angular/core';
import {FrontendFormComponent} from '@abstract/frontend.form.component';
import {ActivatedRoute, Router} from '@angular/router';
import {WorkingObjectsStatusesProvider} from '@providers/working-objects-statuses/working-objects-statuses.provider';
import {WorkingObjectsApiService} from '@api/working-objects.api.service';
import {FormArray, FormGroup} from '@angular/forms';
import {UserNamespace} from '@namespaces/user.namespace';
import {WorkingObjectNamespace} from '@namespaces/working-object.namespace';
import {Anchor} from '@layoutComponents/page-inside-navigation/anchor.interface';
import {RoutesStorage} from '@helpers/routes.helper';
import {Observable} from 'rxjs/internal/Observable';
import {SelectValueInterface} from '@interfaces/select-value.interface';
import {map} from 'rxjs/operators';
import {NotyMessagesEnum} from '@helpers/noty-messages.enum';

@Component({
    selector: 'app-object-form',
    templateUrl: 'object-form.component.html',
    providers: []
})

export class ObjectFormComponent extends FrontendFormComponent {

    public afterSaveMessage = NotyMessagesEnum.workingObjectUpdatedMessage;

    public anchors: Anchor[] = [
        {targetId: 'common', title: 'Информация об объекте'},
        {targetId: 'order',  title: 'Данные договора'},
        {targetId: 'leader', title: 'Руководитель проекта'},
        {targetId: 'config', title: 'Требования'},
        {targetId: 'place',  title: 'Местоположение'},
    ];

    public listUrl = RoutesStorage.WorkingObject.list;
    public viewUrl: string;

    public permissions = UserNamespace.Permission;

    public objectStatuses$: Observable<SelectValueInterface[]>;

    constructor(
        injector: Injector,
        public formService: WorkingObjectsApiService,
        private objectStatusesProvider: WorkingObjectsStatusesProvider,
        private router: Router,
        private route: ActivatedRoute,
    ) {
        super(injector);
    }

    init() {
        this.form = this._fb.group({
            id: [''],
            name: [''],
            short_name: [''],
            status: [WorkingObjectNamespace.Status.new],
            org_customer: [''],
            date_begin: [''],
            date_end: [''],
            leader_id: [''],
            notice: [''],
            no_order: [false],

            place: this._fb.group({
                id: [''],
                name: [''],
                address: [''],
            }),

            requirements: this._fb.array([]),
            work_types: this._fb.array([]),
            orders: this._fb.array([]),
        });

        const values = this.route.snapshot.data.data;

        if (values) {
            this.setFormValues(values, this.form);

            if (values.id) {
                this.viewUrl = RoutesStorage.WorkingObject.view(values.id);
                /**
                 * При редактировании объекта разрешены все статусы
                 */
                this.objectStatuses$ = this.objectStatusesProvider.data$.asObservable();
            } else {
                /**
                 * При создании нового объекта запрещены все статусы, кроме "Новый"
                 */
                this.objectStatuses$ = this.objectStatusesProvider.data$.pipe(
                    map(statuses => statuses.filter(s => s.id === WorkingObjectNamespace.Status.new))
                );
                this.form.get('status').disable();
            }
        }

        this.restoreFormStructure();
    }

    /**
     * Восстановить структуру формы до необходимой, так как при создании и редактировании
     * исходная структура данных для формы отличается
     */
    restoreFormStructure() {
        const orders = this.form.get('orders') as FormArray;
        const requirements = this.form.get('requirements') as FormArray;
        const workTypes = this.form.get('work_types') as FormArray;

        /**
         * Должен быть как минимум один договор
         */
        if (!orders.length) {
            orders.push(this._fb.group({
                signing_date: [''],
                number: [''],
                files: this._fb.array([]),
            }));
        }

        /**
         * Дизайблим динамические чекбоксы, если это необходимо
         */
        [requirements, workTypes].forEach(array => {
            array.controls.forEach((group: FormGroup) => {
                const disabled = group.contains('disabled') ? group.get('disabled').value : false;
                const control = group.get('checked');

                if (control && disabled) {
                    control.disable();
                }
            });
        });
    }

    afterSave() {
        super.afterSave();
        const id = this.form.get('id').value;
        this.viewUrl = RoutesStorage.WorkingObject.view(id);
        this.router.navigate([this.viewUrl]);
    }
}
